import React, { useEffect, useState } from "react";
import Icons from "../../assets/images/index";
import Accordion from "react-bootstrap/Accordion";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { useDispatch } from "react-redux";
import { listProjects, addMedia, deleteDocument } from "../../services/project";
import moment from 'moment';
import _ from 'underscore';
import { API_BASEURL } from "../../environment";
import { failed, success } from "../../components/common/Toastify";
import { message, options, pagination, PaginationOption } from "../../components/common/utils/message";
import { alert, confirm } from "react-bootstrap-confirmation";

const DocumentsList = () => {
    const dispatch = useDispatch();

    const [resPayload, setResPayload] = useState();
    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [projid, setProjid] = useState('');

    useEffect(() => {
       
        listProjects({ page: pagination.page }, (data) => {
            setResPayload(data)
        }, dispatch)
    _getListing();
    }, [dispatch])


    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
        setIsFilePicked(true);
    };

    /**
  * @description Function is for add Media.
  * @param {object} data 
  */
    const _submitData = (data) => {

        const formData = new FormData();
        formData.append('id', projid);
        formData.append('standard_contract', selectedFile);
        try {
            addMedia(formData, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message)
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

      /**
     * @description get all the contractors from db where page is pageChange and Limit for limit of the data.
     */
       const _getListing = () => {
        listProjects({ page: pagination.page }, (data) => {
            setResPayload(data)
        }, dispatch)
    }

    /**
   * @description Function For delete Document.
   * @param {id} id 
   */
    const _handleDelete = async (id) => {
        const result = await confirm(message.deleteData, options);
        if (result) {
            deleteDocument(id, async res => {
                if (res.status === "SUCCESS" && res.code === 200) {
                    // _getListing();
                    success(res.message);
                    await alert(message.MediaDeleted);
                    window.location.reload(false)
                }
            })
        }
    }

    return (
        <div className="dashboard-inner">
            {/* <div className="d-h-wrap">
               
                <div className="d-h-r">
                    <ul className="dashboard-sub-filters">
                        <li>
                            <div className="sortby">
                                <span>State : </span>
                                <div className="nocolor-dropdown">
                                    <select>
                                        <option>California</option>
                                        <option>California</option>
                                        <option>California</option>
                                        <option>California</option>
                                    </select>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div className="sortby">
                                <span>Sort by : </span>
                                <div className="nocolor-dropdown">
                                    <select>
                                        <option>Active</option>
                                        <option>Inactive</option>
                                    </select>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div> */}
            <div className="d-h-wrap">
                <div className="d-h-l">
                    <h4 className='dashboard-heading'>Document</h4>
                </div>
            </div>
            <div className="accordians">
                <Accordion >
                    {resPayload?.docs?.map((item, index) => (
                        <Accordion.Item eventKey={index} key={index}>
                            <Accordion.Header onClick={() => setProjid(item._id)}>{item.project_title}</Accordion.Header>
                            <Accordion.Body>
                                <h5 className="sm-heading">Documents</h5>
                                <div className="f-row alignTop">
                                    <div className="f-60">
                                        <ul className="documents-list">
                                            <li>
                                                {item?.media?.map((doc, ind) => (
                                                    <div className="document" key={ind}>
                                                        <span className="document-icon">
                                                            <img src={Icons.Document} alt="" />
                                                        </span>
                                                        <h4 className="document-title">{doc.filename}</h4>
                                                        <p className="document-date">{moment(doc.createdAt).format('DD/MM/YYYY')}</p>
                                                        <div className="document-actions">
                                                            <div className="d-action">
                                                                <button className="btn-download">
                                                                    <a href={`${API_BASEURL}/${doc.path}`} >
                                                                        <img src={Icons.Download} alt="" />
                                                                    </a>
                                                                </button>
                                                            </div>

                                                            {/* <div className="d-action">
                                                                <DropdownButton className="btn-dot" id="dropdown-basic" drop="up" align={'end'}>
                                                                    <Dropdown.Item href="#/action-1" active>Action 1</Dropdown.Item>
                                                                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                                                </DropdownButton>
                                                            </div> */}
                                                            <button className="dashboard-action" title="Delete" onClick={() => _handleDelete(doc._id)}>
                                                                <img src={Icons.bin} alt="" />
                                                            </button>
                                                        </div>

                                                    </div>
                                                ))}
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="f-40">
                                        <div className="upload-docs">
                                            <h5 className="sm-heading">Upload Documents</h5>
                                            <p className="sm-des">Attach the file below</p>
                                            <label className="upload-area" htmlFor="upload001">
                                                <input type="file" name="file" id="upload001" onChange={changeHandler} />
                                                <div className="upload-doc-desc">
                                                    <span>
                                                        <svg width="26" height="31" viewBox="0 0 26 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.34276 0.0332742C5.26458 0.197827 3.52332 0.908157 2.08063 2.58792C0.717205 4.17537 0.224346 5.79752 0.0598725 9.23863C-0.0199575 10.9082 -0.0199575 20.1071 0.0598725 21.7767C0.221971 25.1682 0.711391 26.8108 2.0228 28.3642C3.31771 29.8982 4.81317 30.6163 7.31128 30.9039C8.42452 31.032 17.5755 31.032 18.6888 30.9039C21.197 30.6152 22.69 29.8983 23.9722 28.3668C25.2934 26.7888 25.7747 25.1827 25.9379 21.807C26.0195 20.1216 26.0211 10.9316 25.9402 9.23863C25.7755 5.7925 25.2834 4.17611 23.9134 2.5808C22.4988 0.933708 20.9203 0.270548 17.9084 0.0580793C17.0391 -0.00325545 9.3968 -0.0230453 8.34276 0.0332742ZM16.0009 2.54603C16.0013 3.57551 16.2459 4.8062 16.6548 5.83588C17.2783 7.40665 18.5001 8.86961 19.9078 9.73141C20.8339 10.2984 22.2433 10.7626 23.0433 10.7641C23.2098 10.7644 23.4938 10.7839 23.6743 10.8074L24.0024 10.8502L24.0013 15.7034C23.9998 21.6669 23.938 23.1222 23.6245 24.5758C23.2358 26.3779 21.9773 27.8392 20.348 28.38C19.1622 28.7736 17.8699 28.8576 13 28.8576C8.13015 28.8576 6.83786 28.7736 5.65204 28.38C4.72296 28.0716 3.89153 27.4428 3.23845 26.5547C2.47865 25.5214 2.19428 24.3597 2.06063 21.7428C1.98198 20.2039 1.98198 10.8114 2.06063 9.27252C2.19428 6.65559 2.47865 5.49389 3.23845 4.46062C3.92097 3.5324 4.75047 2.92102 5.75075 2.60906C6.93576 2.23943 7.84746 2.17829 12.3593 2.16616L16.0007 2.15634L16.0009 2.54603ZM19.3478 2.3972C20.0681 2.51662 20.6749 2.71845 21.1893 3.0098C22.3285 3.65494 23.2456 4.89823 23.5865 6.25939C23.7158 6.77562 23.8765 7.92119 23.877 8.32945L23.8774 8.64013L23.3617 8.61275C21.3341 8.50499 19.5225 7.21614 18.6212 5.24001C18.2561 4.43948 18.074 3.71397 18.0206 2.84647L17.9818 2.21503L18.3822 2.25928C18.6024 2.28361 19.0369 2.34569 19.3478 2.3972ZM12.6713 11.6037C12.3644 11.7253 12.266 11.8191 12.1203 12.1287C12.0107 12.3616 11.9998 12.5403 11.9998 14.1115V15.8383L10.3588 15.8593C8.50117 15.8832 8.41665 15.9047 8.13702 16.4264C7.87097 16.9226 8.01837 17.5086 8.49842 17.8628C8.69977 18.0114 8.7471 18.0153 10.3496 18.0153H11.9941L12.0126 19.8403C12.0301 21.5691 12.0379 21.6755 12.1618 21.8566C12.3837 22.1809 12.674 22.3527 13 22.3527C13.3261 22.3527 13.6164 22.1809 13.8382 21.8566C13.9621 21.6755 13.97 21.5691 13.9875 19.8403L14.006 18.0153H15.6505C17.253 18.0153 17.3003 18.0114 17.5016 17.8628C17.8008 17.642 17.9481 17.3944 17.9836 17.0522C18.0244 16.6595 17.839 16.2557 17.5186 16.0397C17.2885 15.8847 17.2384 15.8799 15.6412 15.8593L14.0003 15.8383V14.1115C14.0003 12.5275 13.9901 12.363 13.8772 12.1231C13.658 11.6573 13.1203 11.4257 12.6713 11.6037Z" fill="#3D5170" />
                                                        </svg>
                                                    </span>
                                                    <h5>Drag file(s) here to upload</h5>
                                                    <p>Alternatively, you can select file by</p>
                                                    <h6>Clicking here.</h6>
                                                </div>
                                            </label>
                                            <div className="f-row">
                                                <div className="f-50 m-b-20">
                                                    <button className="btn btn-grey fullWidth">Cancel</button>
                                                </div>
                                                <div className="f-50 m-b-20">
                                                    <button className="btn btn-blue fullWidth" onClick={_submitData}>Upload File</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </div>
        </div>
    )
}

export default DocumentsList

